export const BASE_API_URL = '/api'
